import React, {Component} from 'react'
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import Table from "../../components/Table/Table";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import 'moment/locale/tr';
import {deepCopyObject, getYearsList, hasUserRight, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import {UserRightsEnum} from "../../helper/enums";
import SecondaryCopyTransferFile from "./SecondaryCopyTransferFile";
import Alert from "react-s-alert";


class secondaryCopyTransfer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: [],
            loading: false,
            total: 0,
            page: 0,
            size: 5,
            searchQuery: undefined,
            secondaryCopyTransferFile: false,
            selected: [],
        }

        this.fetchData = this.fetchData.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.openSecondaryCopyTransferFile = this.openSecondaryCopyTransferFile.bind(this);
        this.closeSecondaryCopyTransferFile = this.closeSecondaryCopyTransferFile.bind(this);
        this.deleteSelected = this.deleteSelected.bind(this);
    }

    componentDidMount() {
        this.setState({year:[]});
    }

    fetchData(){
        let self = this;
        let formdata = new FormData;
        formdata.append("year",this.state.searchQuery ? this.state.searchQuery.split('=')[1] : '');
        let params = {
            url: "/secondaryCopyTransfer/fetch",
            method: "post",
            data: formdata,
        }
        self.setState({loading: true});
        request(params)
            .then(function (response) {
                response.data.map(data => {
                    data.status = data.status === "WAITING" ? "Bekliyor" : (data.status === "IN_QUEUE" ? "Sırada" :
                        (data.status === "TRANSFERRED" ? "Aktarıldı." : (data.status === "ERROR" ? "Hatalı" :
                            (data.status === "EMPTY" ? "Boş" : data.status))));
                });
                let years = [];
                response.data.forEach(c => {
                    const index = years.findIndex(o => o.value === c.year);
                    if (index === -1){
                        years.push({value:c.year,label:c.year});
                    }
                });
                years.sort(function(a,b){
                    return a.value-b.value
                });
                if (self.state.year.length===0){
                    self.setState({year:years});
                }
                response.data.sort(function(a,b){
                    return b.year-a.year || b.month-a.month
                });
                self.setState({content:response.data,loading: false});
            }).catch(function (error) {
                showAxiosError(error);
            });
    }

    handleSearch(searchQuery) {
        this.setState({searchQuery, searching: true}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
    }

    openSecondaryCopyTransferFile(row){
        this.setState({secondaryCopyTransferFile: true, selected: row});
    }

    closeSecondaryCopyTransferFile(){
        this.setState({secondaryCopyTransferFile: false});
    }

    deleteSelected(row) {
        let self = this;
        let formData = new FormData;
        formData.append("recordId", row.recordId.toString())
        let params = {
            url:`/secondaryCopyTransfer/delete`,
            method :'post',
            data: formData
        };
        request(params)
            .then(function (response) {
                Alert.success("Yeniden deneme başlatildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                self.fetchData();
            }).catch(function (error) {
            showAxiosError(error);
        });

    }


    render() {
        const columns = [
            {
                Header: "Yıl",
                accessor: "year",
                sortable: false,
            },
            {
                Header: "Ay",
                accessor: "month",
                sortable: false,
            },
            {
                Header: "Durum",
                accessor: "status",
                sortable: false,
            },
            {
                Header: "Mesaj",
                accessor: "message",
                sortable: false,
            },
            {
            Header: "Detay",
            accessor: "",
            Cell: row => (
            <div>
                {(row.status === "Hatalı" || row.status === "Boş") &&
                    <button type="button"
                            onClick={() => this.deleteSelected(row)}
                            data-toggle="tooltip" data-placement="bottom" title="Yeniden dene"
                            style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}
                            rel="tooltip"
                            className="Btn btn-icon">
                        <i className="fas fa-refresh"/>
                    </button>}
                <button type="button"
                        onClick={() => this.openSecondaryCopyTransferFile(row)}
                        data-toggle="tooltip" data-placement="bottom" title="Detayları Görüntüle"
                        style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
                        rel="tooltip"
                        className="Btn btn-icon">
                    <i className="far fa-address-card"/>
                </button>
            </div>
        )
    }
                    ];



        const fields = [
            {
                label: "Yıl",
                accessor: "year",
                type: "select",
                operator: "=",
                selectData: [{label: 'Tümü', value: ''}].concat(this.state.year)
            }];

        return(
            <div className="row baseBackground">
                <div className="col-sm-12 satirBasi">
                    <div className="card-header">
                        <h4 className="card-title">E-Defter İkincil Kopya Bildirimi</h4>
                    </div>
                    <div className="card-body">
                        <DetailedSearch fields={fields}
                                        loading={this.state.searching}
                                        onSearch={this.handleSearch}/>
                    </div>
                    <div className="card-body row">
                        <Table columns={columns}
                               content={this.state.content}
                               paginationEnabled={false}
                               fetchData={this.fetchData}
                        />
                    </div>
                </div>
                {this.state.secondaryCopyTransferFile &&
                    <SecondaryCopyTransferFile
                        modal={this.state.secondaryCopyTransferFile}
                        toggle={this.closeSecondaryCopyTransferFile}
                        selected={this.state.selected}
                    />
                }

            </div>
        )
    }

}
export default secondaryCopyTransfer;
